import React from "react";
import { waybillTitleStatuses, waybillTitleStatusesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import { isWaybillTitleRejected, isWaybillTitleSignatureInvalid } from "helpers/waybills";

/** Show the operator's failure status before local signing metadata in both detailed title views. */
export const WaybillTitleStatusBadge = ({
    title,
    label,
    failed,
}: {
    title: { signed: boolean; status?: string; rejectionReason?: string | null };
    label: string;
    failed: boolean;
}) => (
    <span
        className={`badge ${isWaybillTitleRejected(title) || isWaybillTitleSignatureInvalid(title) || failed ? "badge-danger" : title.signed ? "badge-success" : "badge-secondary"}`}
    >
        {isWaybillTitleRejected(title)
            ? "Отказ в подписи"
            : isWaybillTitleSignatureInvalid(title)
              ? enumLabel(waybillTitleStatuses, waybillTitleStatusesEnum.InvalidSignature)
              : failed && title.status
                ? enumLabel(waybillTitleStatuses, title.status)
                : label}
    </span>
);

/** Explain the two recovery actions for the operator's invalid-signature result. */
export const WaybillTitleSignatureWarning = ({ title }: { title: { status?: string } }) =>
    isWaybillTitleSignatureInvalid(title) ? (
        <div className="alert alert-danger mt-2 mb-2" role="alert">
            Подпись не прошла проверку в Контуре. Подпишите титул повторно или сформируйте новый
        </div>
    ) : null;

/** Display the operator's full rejection reason without truncating its text. */
export const WaybillTitleRejection = ({ rejectionReason }: { rejectionReason?: string | null }) =>
    rejectionReason ? (
        <div className="alert alert-danger mt-2 mb-2 text-break" role="alert">
            <div className="font-weight-bold">Причина отказа</div>
            <div className="white-space-pre-line">{rejectionReason}</div>
        </div>
    ) : null;
